import React, { useState } from 'react'
import {
  makeStyles,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core'
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle'
import { Step } from '../../../types/steps'

const useStyles = makeStyles(() => ({
  accordion: {
    background: 'transparent',
    borderRadius: '1rem',
    border: 0,
    margin: '1rem 0',
    '&:first-child': {
      borderTopLeftRadius: '1rem',
      borderTopRightRadius: '1rem',
    },
    '&:before': {
      display: 'none',
    },
  },
  expandedAccordion: {
    background: 'rgba(0, 0, 0, 0.04)',
  },
  accordionSummary: {
    borderRadius: '1rem',
    fontWeight: 'bold',
    letterSpacing: '-0.02em',
    color: '#2B1841',
    fontSize: '1.2rem',
    fontFamily: '"Inter"',
  },
  accordionDetails: {
    flexDirection: 'column',
    fontSize: '1rem',
    color: '#7D7787',
    letterSpacing: '0.005em',
  },
  accordionCTA: {
    background: 'rgba(0, 0, 0, 0.06)',
    color: 'black',
    margin: '1rem 0',
    textTransform: 'unset',
  },
  downIcon: {
    margin: '0 1rem',
  },
  icon: {
    color: 'rgba(0,0,0,0.2)',
  },
}))

export default function index({ steps }: { steps: Step[] }): JSX.Element {
  const classes = useStyles({})
  const [active, setActive] = useState(0)
  return (
    <div>
      {steps.map((item, index) => (
        <Accordion
          key={index}
          classes={{ root: classes.accordion, expanded: classes.expandedAccordion }}
          expanded={active === index}
          onChange={() => {
            setActive(index)
          }}
        >
          <AccordionSummary classes={{ root: classes.accordionSummary }}>
            <ArrowDropDownCircleIcon className={classes.icon} />
            <span className={classes.downIcon}>
              {index + 1}. {item.summary}
            </span>
          </AccordionSummary>

          <AccordionDetails className={classes.accordionDetails}>
            {item.details}
            {item.action && (
              <Button
                color="primary"
                variant="contained"
                disableElevation
                className={classes.accordionCTA}
                href={item.action.link}
              >
                {item.action.label}
              </Button>
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  )
}
